import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, IconButton, Tooltip } from '@mui/joy';
import { Question } from '@phosphor-icons/react';
import { usePageHelpIndex, matchHelpRoute } from '../../hooks/usePageHelp';
import { KnowledgeBaseDrawer } from './KnowledgeBaseDrawer';

/**
 * "How to use this page" help icon, intended to sit next to a page title. It
 * renders only when the current route has a Knowledge Base article, and opens
 * the help drawer on click.
 */
export const PageHelpButton: React.FC<{ label?: boolean; inverse?: boolean }> = ({ label = false, inverse = false }) => {
  const location = useLocation();
  const { data: index } = usePageHelpIndex();
  const [open, setOpen] = useState(false);

  const route = matchHelpRoute(location.pathname, index);
  if (!route) return null;

  return (
    <>
      {label ? <Button variant="plain" size="sm" startDecorator={<Question />} onClick={() => setOpen(true)} aria-label="How to use this page" sx={inverse ? { color: 'white', whiteSpace: 'nowrap', '&:hover': { bgcolor: 'rgba(255,255,255,.12)' } } : undefined}>Page guide</Button> : <Tooltip title="How to use this page" variant="soft" placement="bottom">
        <IconButton
          variant="soft"
          color="primary"
          size="sm"
          onClick={() => setOpen(true)}
          aria-label="How to use this page"
          sx={{ borderRadius: '50%', flexShrink: 0 }}
        >
          <Question weight="bold" />
        </IconButton>
      </Tooltip>}
      <KnowledgeBaseDrawer open={open} onClose={() => setOpen(false)} route={route} />
    </>
  );
};
